module.exports = window.ReactJSXRuntime;